import { render, staticRenderFns } from "./printLaosSales.vue?vue&type=template&id=7946c2d9&scoped=true&"
import script from "./printLaosSales.vue?vue&type=script&lang=js&"
export * from "./printLaosSales.vue?vue&type=script&lang=js&"
import style0 from "./printLaosSales.vue?vue&type=style&index=0&id=7946c2d9&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7946c2d9",
  null
  
)

component.options.__file = "printLaosSales.vue"
export default component.exports